import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/main'
import Lxwm from '@/view/lxwm'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: { name: 'index' },
      children: [
        {
          path: '/index',
          name: 'index',
          component: () => import('@/view/index/index'),
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('@/view/about-us/aboutUs'),
          redirect: { name: 'aboutCnew' },
          children:[
            {
              path: '/aboutCnew',
              name: 'aboutCnew',
              component: () => import('@/view/about-us/aboutCnew'),
            },
            {
              path: '/hostory',
              name: 'hostory',
              component: () => import('@/view/about-us/hostory'),
            },
            ,
            {
              path: '/honour',
              name: 'honour',
              component: () => import('@/view/about-us/honour'),
            },
          ]
          
        },
        {
          path: '/hxjs',
          name: 'hxjs',
          component: () => import('@/view/hxjs/hxjs'),
          redirect: { name: 'coreTechnology' },
          children:[
            {
              path: '/coreTechnology',
              name: 'coreTechnology',
              component: () => import('@/view/hxjs/coreTechnology'),
            },
            {
              path: '/5Key',
              name: '5Key',
              component: () => import('@/view/hxjs/5Key'),
            },
            ,
            {
              path: '/algorithm',
              name: 'algorithm',
              component: () => import('@/view/hxjs/algorithm'),
            },
          ]
        },
        {
          path: '/cpzx',
          name: 'cpzx',
          component: () => import('@/view/cpzx/cpzx'),
          redirect: { name: 'programme' },
          children:[
            {
              path: '/programme',
              name: 'programme',
              component: () => import('@/view/cpzx/programme'),
            },
            {
              path: '/operatingRoom',
              name: 'operatingRoom',
              component: () => import('@/view/cpzx/operatingRoom'),
            },
          ]
        },
        {
          path: '/news',
          name: 'news',
          component: () => import('@/view/news/news'),
        },
        {
          path: '/support',
          name: 'support',
          component: () => import('@/view/support/support'),
        },
        {
          path: '/join',
          name: 'join',
          component: () => import('@/view/join-us/joinUs'),
          redirect: { name: 'position' },
          children:[
            {
              path: '/position',
              name: 'position',
              component: () => import('@/view/join-us/position'),
            },
         
            
            {
              path: '/welfare',
              name: 'welfare',
              component: () => import('@/view/join-us/welfare'),
            },
            {
              path: '/environment',
              name: 'environment',
              component: () => import('@/view/join-us/environment'),
            },
            {
              path: '/contactUs',
              name: 'contactUs',
              component: () => import('@/view/join-us/contactUs'),
            }
          ]
        },
        {
          path: '/positionDetail/:id',
          name: 'positionDetail',
          component: () => import('@/view/join-us/positionDetail'),
        }
      ]
    },
    {
      path: '/lxwm',
      name: 'lxwm',
      component: Lxwm
    }
  ],



})



// WEBPACK FOOTER //
// ./src/router/index.js